export default [
  {
    type: "monthly",
    year: 2021,
    month: 1,
    btc: 93,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/ry4z38r"
  },
  {
    type: "monthly",
    year: 2021,
    month: 2,
    btc: 129,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/xppo09x"
  },
  {
    type: "monthly",
    year: 2021,
    month: 3,
    btc: 165,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/xlqozjw"
  },
  {
    type: "monthly",
    year: 2021,
    month: 4,
    btc: 163,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/xq6k1lr"
  },
  {
    type: "monthly",
    year: 2021,
    month: 5,
    btc: 252,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/ry1p63r"
  },
  {
    type: "monthly",
    year: 2021,
    month: 6,
    btc: 167,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/rdgy24r"
  },
  {
    type: "monthly",
    year: 2021,
    month: 7,
    btc: 225,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/x8qq55x"
  },
  {
    type: "monthly",
    year: 2021,
    month: 8,
    btc: 206,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/w0490lx"
  },
  {
    type: "monthly",
    year: 2021,
    month: 9,
    btc: 165,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/r728l7w"
  },
  {
    type: "monthly",
    year: 2021,
    month: 10,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 11,
    btc: 0,
    source: ""
  },
  {
    type: "monthly",
    year: 2021,
    month: 12,
    btc: 0,
    source: ""
  },
  /* Quarterly */
  {
    type: "quarterly",
    year: 2020,
    quarter: 1,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 2,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 3,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2020,
    quarter: 4,
    btc: 0,
    source: ""
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 1,
    btc: 387,
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/xlqozjw"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 2,
    btc: 496, // 883 - 387
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/rdgy24r"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 3,
    btc: 596, // 1479 - 883
    source: "https://polaris.brighterir.com/public/argo_blockchain/news/rns/story/r728l7w"
  },
  {
    type: "quarterly",
    year: 2021,
    quarter: 4,
    btc: 0,
    source: ""
  },
]
